import { ArrowUpRight } from "lucide-react";

const AREAS = [
  {
    number: "01",
    title: "Perícia Judicial",
    text: "Atuação como perito nomeado pelo Juízo em ações cíveis, criminais, trabalhistas e da família.",
  },
  {
    number: "02",
    title: "Assistência Técnica",
    text: "Suporte técnico a advogados, escritórios, clínicas e empresas em processos judiciais e extrajudiciais.",
  },
  {
    number: "03",
    title: "Erro Odontológico",
    text: "Análise de planejamento, conduta profissional, documentação clínica e nexo causal entre conduta e dano.",
  },
  {
    number: "04",
    title: "Avaliação de Danos",
    text: "Análise de danos por acidentes de trânsito, trabalho, agressões, quedas e traumas faciais.",
  },
  {
    number: "05",
    title: "Odontologia do Trabalho",
    text: "Saúde bucal ocupacional, pareceres técnicos e programas preventivos para empresas.",
  },
];

export const Areas = () => {
  return (
    <section
      id="atuacao"
      data-testid="areas-section"
      className="relative py-24 md:py-32 bg-[#050505]"
    >
      <div className="w-full max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-32">
              <div className="flex items-center gap-3 mb-6">
                <span className="h-px w-10 bg-[#D4AF37]" />
                <span className="text-xs tracking-[0.32em] uppercase text-[#D4AF37]">
                  Áreas de Atuação
                </span>
              </div>
              <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl text-white leading-tight tracking-tight">
                Onde a perícia odontológica{" "}
                <span className="italic text-[#D4AF37]">faz a diferença</span>.
              </h2>
              <p className="mt-6 text-white/65 leading-relaxed">
                Atendimento a magistrados, advogados, escritórios, empresas,
                seguradoras e particulares em todo o território nacional.
              </p>
            </div>
          </div>

          <div className="lg:col-span-8">
            <ul>
              {AREAS.map((area, i) => (
                <li
                  key={i}
                  data-testid={`area-item-${i}`}
                  className="group border-b border-[#D4AF37]/15 py-8 first:border-t flex items-start justify-between gap-6 hover:bg-[#0a0a0a] transition-colors duration-300 px-2 -mx-2"
                >
                  <div className="flex items-start gap-6 sm:gap-8 flex-1">
                    <span className="font-serif-display text-sm text-[#D4AF37]/70 mt-2">
                      {area.number}
                    </span>
                    <div className="flex-1">
                      <h3 className="font-serif-display text-2xl sm:text-3xl text-white group-hover:text-[#D4AF37] transition-colors duration-300">
                        {area.title}
                      </h3>
                      <p className="mt-2 text-sm sm:text-base text-white/55 leading-relaxed max-w-2xl">
                        {area.text}
                      </p>
                    </div>
                  </div>
                  <ArrowUpRight
                    size={28}
                    strokeWidth={1.2}
                    className="text-[#D4AF37]/40 group-hover:text-[#D4AF37] group-hover:rotate-12 transition-all duration-300 shrink-0 mt-2"
                  />
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
